import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.kreonet.availability.detail');
import { OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-kreonet-availability-detail',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.kreonet.availability.detail/view.scss */
/* src/app/portal.kreonet.availability.detail/view.scss: no such file or directory */`],
})
export class PortalKreonetAvailabilityDetailComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    @Input() detailData: any;
    @Input() months: any;
    @Input() showDetailModal: any;
    @Output() show = new EventEmitter<boolean>();

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(true, "/authenticate");
    }

    public async hide() {
        this.show.emit(false);
        await this.service.render();
    }
}

export default PortalKreonetAvailabilityDetailComponent;